import React, { useState, useEffect } from "react";
import categories from "./Categories";
import images from "./Images";
import berastyles from './styles/bera.module.css';

function Bera() {
    const [currentCategory, setCurrentCategory] = useState(1);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMousePosition, setModalMousePosition] = useState({ x: 0, y: 0 });
    const [isMenuActive, setIsMenuActive] = useState(false);
    useEffect(() => {
        // Suchen des Index des ersten Bildes in der aktuellen Kategorie
        const firstImageIndexInCategory = images.findIndex(image => image.category === currentCategory);
        if (firstImageIndexInCategory !== -1) {
            setCurrentImageIndex(firstImageIndexInCategory);
        }
    }, [currentCategory]);
    const toggleMenu = () => {
        setIsMenuActive(!isMenuActive);
    };
    const handleCategoryClick = (categoryId) => {
        setCurrentCategory(categoryId);
        toggleMenu(); // Menü schließen
    };
    const openModalWithImageIndex = (index) => {
        setCurrentImageIndex(index);
        openModal();
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const goToNextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const goToPrevImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    return (
        <div className={berastyles.beraframe}>
            <div className={berastyles.gridrow}>
                <div className={berastyles.mobilemenu} onClick={toggleMenu}>MENU</div>
                <nav>
                    <ul className={`${berastyles.capitals} ${isMenuActive ? berastyles.activemenu : ''}`}>
                        {categories.map(category => (
                            <li key={category.id}>
                                <button onClick={() => handleCategoryClick(category.id)}>{category.name}</button>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div
                    className={berastyles.imagecontainer}
                    onMouseMove={(event) => setModalMousePosition({ x: event.clientX, y: event.clientY })}
                >
                    {images.map((image, index) => (
                        <img
                            key={image.id}
                            src={image.src}
                            alt={`Bild ${image.id}`}
                            className={berastyles.image}
                            onClick={() => openModalWithImageIndex(index)}
                            loading="lazy"
                            style={{ display: index === currentImageIndex ? 'block' : 'none' }}
                        />
                    ))}
                </div>
            </div>
            <div className={berastyles["navigation-buttons"]}>
                <button onClick={goToPrevImage}><span>&lt;</span></button>
                <button onClick={goToNextImage}><span>&gt;</span></button>
            </div>
            {isModalOpen && (
                <div className={`${berastyles.modal} ${isModalOpen ? berastyles.active : ''}`}>
                    <div className={berastyles.modalcontent}>
                        <img
                            src={images[currentImageIndex].src}
                            alt={`Bild ${currentImageIndex}`}
                            className={berastyles.modalImage}
                        />
                    </div>
                    <button className={berastyles.closeButton} onClick={closeModal}>
                        <span className={berastyles.closeIcon}>X</span>
                    </button>
                </div>
            )}
        </div>
    );
}

export default Bera;
